<template>
  <div class="flex-1 flex flex-col justify-between">
    <div class="divide-y divide-gray-200">
      <div class="space-y-6 pt-6 pb-5">
        <transition
          mode="out-in"
          enter-active-class="transform ease-out duration-300 transition"
          enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
          leave-active-class="transition ease-in duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0">
          <Form
            v-slot="{ values }"
            :initial-values="initial_values"
            :validation-schema="schema"
            class="mt-2 space-y-6"
            @submit="editJourney">
            <div class="rounded-md shadow-sm flex gap-1 justify-between items-center">
              <TextInput
                label=""
                :classes="'w-full'"
                input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                name="name"
                type="text"
                :placeholder="$t('Journey name')" />
            </div>

            <div class="mt-4">
              <SelectInput
                :disabled="!!journey.phases.length"
                :items="$store.state.object_types"
                name="object_type"
                label-attr="label"
                :classes="`w-full mb-6`"
                :is-box-background="true"
                :inline-label="true"
                :show-label="false" />
            </div>

            <div class="flex gap-2 w-full flex-row justify-between">
              <button type="cancel" class="cancel-btn w-1/2" @click="$emit('cancel')">{{ $t("Cancel") }}</button>
              <button type="submit" class="primary-btn w-1/2" @click="editJourney(values)">{{ $t("Edit Journey") }}</button>
            </div>
          </Form>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import * as Yup from "yup"
import TextInput from "@/components/shared/TextInput.vue"
import SelectInput from "@/components/shared/SelectInput.vue"
import { Form } from "vee-validate"
import dataService from "@/services/data.service"
import { useStore } from "vuex"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
export default {
  components: {
    TextInput,
    SelectInput,
    Form
  },

  props: {
    journey: {
      type: Object,
      required: false
    }
  },

  emits: ["cancel", "submitted", "done"],
  setup(props) {
    const store = useStore()
    const schema = Yup.object().shape({
      name: Yup.string().required(),
      tag: Yup.string().required()
      //TODO : the rest of the fields
    })

    const initial_values = {
      name: props.journey.name,
      object_type: store.state.object_types.filter((o) => o.id == props.journey.object_type)[0]
    }

    return {
      schema,
      initial_values
    }
  },
  data() {
    return {}
  },

  methods: {
    editJourney(values) {
      dataService.updateJourney(this.journey.id, { ...values, object_type: values.object_type.id }).then(() => {
        this.$emitter.emit(ALL_EMITTERS.UPDATE_JOURNEY_IN_CUSTOMER_JOURNEYS_VIEW, this.journey)
        this.$emitter.emit(ALL_EMITTERS.UPDATE_JOURNEY_IN_JOURNEYS, this.journey)
        this.$emit("done")
      })
    }
  }
}
</script>

<style>
input[type="color"]::-webkit-color-swatch-wrapper {
  padding: 0;
}

input[type="color"]::-webkit-color-swatch {
  border: none;
  border-radius: 10px;
}
</style>
